
/* eslint-disable */
const createCsvLabelsConf = (arr) => {
  const conf = {};

  arr.forEach((m) => {
    conf[m] = { title: m };
  });

  return conf;
};

const createCsvLabels = (labels, separator) => {
  let row = '';
  let c = '';

  try {
    Object.keys(labels).map((m, i) => {
      row += `"${labels[m].title}"${separator}`;
    });

    row = row.slice(0, -1);

    c += `${row}\r\n`;
  } catch (err) {
    c = 'error';
  } finally {
    return c;
  }
};

const createCsvContent = (arr, labels, separator) => {
  let row = '';
  let c = '';
  let type = '';

  try {
    arr.map((m, i) => {
      row = '';

      Object.keys(labels).map((k, s) => {
        type = typeof m[k];
        if (type === 'number' || type === 'float') {
          row += m[k] + separator;
        } else {
          row += `"${m[k]}"${separator}`;
        }
      });

      row = row.slice(0, -1);

      c += `${row}\r\n`;
    });
  } catch (err) {
    c = 'error';
  } finally {
    return c;
  }
};

const downloadCsv = (uid, csv, title) => {
  try {
    const uri = `${'data:text/csv;charset=utf-8,' + '\uFEFF'}${encodeURIComponent(csv)}`;

    const link = document.createElement('a');

    link.id = `csv-${uid}`;
    link.href = uri;

    document.body.appendChild(link);

    document.getElementById(link.id).style.visibility = 'hidden';
    document.getElementById(link.id).download = `${title}.csv`;

    document.body.appendChild(link);
    document.getElementById(link.id).click();

    setTimeout(() => {
      document.body.removeChild(link);
    });
    return true;
  } catch (err) {
    return false;
  }
};

const handleError = (msg) => {
  throw msg;
};

const downloader = ({
  jsonData,
  csvTitle,
  showLabels = false,
  labels,
  separator = ','
}, successCallback) => {
  let csvLabels, csvData, uid;

  if (!jsonData.length) {
    handleError('Error: Data are empty');
    return;
  }

  if (labels && !Object.keys(labels).length) {
    handleError('Error: Labels are empty');
    return;
  }

  const _labels = Object.getOwnPropertyNames({ ...jsonData[0] });
  const labelsConf = labels || createCsvLabelsConf(_labels);
  csvLabels = showLabels ? createCsvLabels(labelsConf, separator) : '';
  csvData = createCsvContent(jsonData, labelsConf, separator);
  if (csvLabels === 'error' || csvData === 'error') {
    handleError('Error: An error occured while parsing the data.');
    return;
  }
  const content = csvLabels + csvData;
  const f = downloadCsv(`csv-${uid}`, content, csvTitle);
  if (!f) handleError('An error has occured');
  if (f && successCallback) successCallback();
}

export default downloader;
